// Backward compatibility: export DialogWrapper as Modal and default
import { DialogWrapper } from './dialog-wrapper';
import FormWrapper from './form-wrapper';
import ModalTabHeader from './tab-header';

export * from './sub-navigation';
export { DialogWrapper } from './dialog-wrapper';
export { default as FormWrapper } from './form-wrapper';
export { default as TabHeader } from './tab-header';

const Modal = DialogWrapper;
// Add FormWrapper and TabHeader as static properties for backward compatibility
Modal.FormWrapper = FormWrapper;
Modal.TabHeader = ModalTabHeader;

export { Modal };
export { Modal as default };
